import React from 'react';

interface KayakIconProps {
  className?: string;
}

const KayakIcon: React.FC<KayakIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Kayak body */}
      <path d="M2 12 Q6 8, 12 12 Q18 16, 22 12" />
      <path d="M2 12 Q6 16, 12 12 Q18 8, 22 12" />
      {/* Paddle */}
      <path d="M8 6 L16 18" />
      <ellipse cx="7" cy="5" rx="1.5" ry="3" transform="rotate(-35 7 5)" />
      <ellipse cx="17" cy="19" rx="1.5" ry="3" transform="rotate(-35 17 19)" />
    </svg>
  );
};

export default KayakIcon;
